import React, { useState } from "react";
import Petrol from "../../../assets/Petrol.png";
import Diesel from "../../../assets/Diesel.png";
import EV from "../../../assets/EV.png";

const Variant = ({ onSelect }) => {
  const [selectedFuel, setSelectedFuel] = useState(null);
  const [selectedTransmission, setSelectedTransmission] = useState(null);

  const handleFuelSelection = (value) => {
    setSelectedFuel(value);
  };

  const handleSelection = (key, value) => {
    if (key === "transmission") setSelectedTransmission(value);
  };

  React.useEffect(() => {
    if (selectedFuel && selectedTransmission) {
      const data = {
        fuel: selectedFuel,
        transmission: selectedTransmission,
      };
      onSelect("variantSelection", data);
    }
  }, [selectedFuel, selectedTransmission, onSelect]);

  return (
    <section
      style={{
        fontFamily: "Barlow Condensed",
        height: "40rem",
        maxHeight: "90vh",
        overflowY: "auto",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
      className="overflow-y-auto"
    >
      <h4
        style={{ fontFamily: "Ballega" }}
        className="text-center text-3xl sm:text-4xl mb-8 sm:pb-12 pt-6"
      >
        Select The Variant
      </h4>
      <h4 style={{ fontFamily: "Ballega" }} className="text-2xl sm:text-4xl mb-8">
        Select the type of fuel
      </h4>
      <div className="flex justify-center items-center gap-4 sm:gap-24 text-xl sm:text-3xl mb-12">
        <label className="text-center">
          <input
            type="radio"
            name="fuel"
            checked={selectedFuel === "Petrol"}
            onChange={() => handleFuelSelection("Petrol")}
            className="w-6 h-6 sm:w-8 sm:h-8 scale-150"
          />
          <img src={Petrol} alt="Petrol" loading="lazy" className="w-42 h-28 sm:w-48 sm:h-60" />
        </label>
        <label className="text-center">
          <input
            type="radio"
            name="fuel"
            checked={selectedFuel === "Diesel"}
            onChange={() => handleFuelSelection("Diesel")}
            className="w-6 h-6 sm:w-8 sm:h-8 scale-150"
          />
          <img src={Diesel} alt="Diesel" loading="lazy" className="w-42 h-28 sm:w-48 sm:h-60" />
        </label>
        <label className="text-center">
          <input
            type="radio"
            name="fuel"
            checked={selectedFuel === "EV"}
            onChange={() => handleFuelSelection("EV")}
            className="w-6 h-6 sm:w-8 sm:h-8 scale-150"
          />
          <img src={EV} alt="EV" loading="lazy" className="w-42 h-28 sm:w-48 sm:h-60" />
        </label>
      </div>
      <div style={{ fontFamily: "Ballega" }} className="sm:text-3xl mb-8">
        <h4 className="text-2xl sm:text-4xl">Select Transmission type</h4>
        <div className="flex justify-center gap-4 sm:gap-16 my-12">
          <button
            className="border border-black py-4 px-6 sm:px-12"
            onClick={() => handleSelection("transmission", "Automatic")}
          >
            Automatic
          </button>
          <button
            className="border border-black py-4 px-6 sm:px-12"
            onClick={() => handleSelection("transmission", "Manual")}
          >
            Manual
          </button>
        </div>
      </div>
    </section>
  );
};

export default Variant;
